<template>
  <gg-modal :is-active="modal" max-width="400">
      <template v-slot:title>
        Your session is about to end.
      </template>
      <template v-slot:body>
        You’ve been inactive for a while. For your security, we’ll automatically sign you out in approximately 1 minute.
        You may choose “stay signed in” to continue or sign out if you’re done.
      </template>
      <template v-slot:actions>
        <gg-btn secondary color="red" @click="logOut">
          Sign Out
        </gg-btn>
        <gg-btn primary  @click="closeModal">
          Stay Signed in
        </gg-btn>
      </template>
    </gg-modal>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import debounce from 'lodash.debounce'

export default {
  name: 'Idle',
  data: () => ({
    timeout: 10000,
    isActive: 1,
    pingTimer: null,
  }),
  created () {
    this.setDefaults()
  },
  beforeMount () {
    this.activateActivityTracker()
    this.startInterval()
  },
  beforeDestroy () {
    this.deactivateActivityTracker()
    this.stopInterval()
  },
  computed: {
    ...mapGetters({
      modalGetter: 'idle/modal'
    }),
    modal: {
      get () {
        return this.modalGetter
      },
      set (val) {
        this.setModalState(val)
      }
    }
  },
  methods: {
    ...mapActions({
      sessionPing: 'idle/sessionPing',
      attemptLogout: 'attemptLogout',
      reportLogout: 'reportLogout'
    }),
    ...mapMutations({
      setModalState: 'idle/POPULATE_MODAL',
      resetStore: 'idle/CLEAR_IDLE_STORE'
    }),
    setDefaults () {
      this.resetStore()
    },
    activateActivityTracker () {
      window.addEventListener('mousemove', this.detectActivity)
      window.addEventListener('scroll', this.detectActivity)
      window.addEventListener('keydown', this.detectActivity)
      window.addEventListener('resize', this.detectActivity)
      window.addEventListener('touchend', this.detectActivity)
    },
    deactivateActivityTracker () {
      window.removeEventListener('mousemove', this.detectActivity)
      window.removeEventListener('scroll', this.detectActivity)
      window.removeEventListener('keydown', this.detectActivity)
      window.removeEventListener('resize', this.detectActivity)
      window.removeEventListener('touchend', this.detectActivity)
    },
    detectActivity: debounce(() => {
      localStorage.setItem('_lastActivity', Date.now())
    }, 100),
    verifyActivity () {
      const lastActivity = parseInt(localStorage.getItem('_lastActivity'), 10)
      const currentTime = Date.now()

      if (currentTime - lastActivity > this.timeout) {
        this.isActive = 0
      } else {
        this.isActive = 1
      }

      this.sendPing()
    },
    startInterval () {
      this.pingTimer = setTimeout(() => {
        this.verifyActivity()
        this.startInterval()
      }, this.timeout)
    },
    stopInterval () {
      clearInterval(this.pingTimer)
    },
    closeModal () {
      this.modal = false
      this.activateActivityTracker()
      this.startInterval()
    },
    async sendPing () {
      try {
        const { isInactive } = await this.sessionPing(this.isActive)
        if (isInactive && !this.modal) {
          this.modal = true
          this.deactivateActivityTracker()
        }
      } catch (e) {
        console.warn(`Ping error: ${e}`)
      }
    },
    async logOut () {
      try {
        await this.attemptLogout()
        this.reportLogout('You have successfully logged out.')
      } catch (e) {
        this.reportError(e)
      }
    }
  }
}
</script>
